<template>
    <div class="container-fluid">
        <div class="page-heading mb-4">
            <p class="page-eyebrow">EVENT MANAGEMENT</p>
            <h1 class="h3 mb-1 text-gray-800">Add videos</h1>
            <p class="mb-0 text-muted">Link YouTube videos to an event or one of its sessions. They appear in the mobile app.</p>
        </div>

        <VideoGalleryForm :is-new="true"/>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import VideoGalleryForm from '@/components/video-gallery/VideoGalleryForm.vue'

export default defineComponent({
    name: "VideoGalleryAddPage",
    components: {VideoGalleryForm}
})
</script>

<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
